var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":""}},[_c('code',{staticStyle:{"background-color":"black","color":"white","line-height":"1","font-size":"15px"}},[_vm._v(_vm._s(_vm.dungeon))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }